import { Box, useTheme } from "@material-ui/core"
import { useEffect, useState } from "react";
import { connect, mapDispatchToProps, mapStateToProps } from "../../store/dispatchers";
import GroupsExplorer from './GroupsExplorer';
import GroupsSetting from './GroupsSettings';

const Groups = ({rolesAll, updatePermissionsGroup, permList}) => {

    const [groups,setGroups] = useState({});

    const [ permissionsKey, setPermissionsKey ] = useState([]);
    const [ focusedKeyIndex, setFocusedKeyIndex ] = useState(0);

    useEffect(()=>{
        const groupsList = rolesAll.groups ? {...rolesAll.groups} : {};
        setGroups(groupsList);
        let keys = [];
        for (const [key] of Object.entries(groupsList)) {
            keys.push(key);
        }
        setPermissionsKey(keys);
    },[rolesAll]);

    const palette = useTheme().palette;

    const styles = {
        explorer: {
            backgroundColor: palette.admin.main,
        },
        parametersSetting: {
            backgroundColor: palette.admin.light,
        },
    }

    return (
        <Box className="page">
            <Box className="cards-row" height="calc(100vh - 184px)">
                <Box style={styles.explorer} className={`card parameters-explorer`}>
                    <GroupsExplorer
                        keys={permissionsKey}
                        focusedKey={focusedKeyIndex}
                        onKeyClick={(index)=>setFocusedKeyIndex(index)}
                        updatePermissionsGroup={updatePermissionsGroup}
                        permList={permList}
                    />
                </Box>
                <Box style={styles.parametersSetting} className={`card parameters-settings`}>
                    <GroupsSetting
                        focusedKey={focusedKeyIndex}
                        keys={permissionsKey}
                        groups={groups}
                        updatePermissionsGroup={updatePermissionsGroup}
                        permList={permList}
                    />
                </Box>
            </Box>
        </Box>
    )
}

export default connect( mapStateToProps, mapDispatchToProps )(Groups);